import { FC } from 'react';
import { InviteCommunityButton } from '../community/InviteCommunityButton';
import { QuickAddNote } from '../notes/add-note/QuickAddNote';
import { QuickAddAppointment } from '../appointments/QuickAddAppointment';
import { createUseStyles } from 'react-jss';
import { IAppointmentTrackingFrom } from '../appointments/AppointmentsState';

const useStyles = createUseStyles({
    container: {
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',

        '& ion-button::part(native)': {
            paddingInlineStart: 8,
            paddingInlineEnd: 8
        }
    }
});

export const QuickAddButtons: FC<{ trackingFrom?: string; }> = ({ trackingFrom }) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div>
                <QuickAddAppointment useIcon trackingFrom={trackingFrom as IAppointmentTrackingFrom} />
            </div>
            <div>
                <QuickAddNote useIcon trackingFrom={trackingFrom} />
            </div>
            <div>
                <InviteCommunityButton />
            </div>
        </div>
    );
};
